import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getPayspotCurrentBillbox } from '../../../../../actions/devices';
import BillboxHistoryCard from './BillboxHistoryCard';
import BillsBreakdownCard from './BillsBreakdownCard';
import BillsCard from './BillsCard';
import MaintenanceLogsCard from './MaintenanceLogsCard';
import PayspotErrorsCard from './PayspotErrorsCard';
import UsedCapacityCard from './UsedCapacityCard';

const Flex = styled.div`
  display: flex;
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
`;

const FlexColumn = styled.div`
  ${({ flex = 1 }) => `flex: ${flex};`}
`;

const PayspotDetails = ({ payspotId }) => {
  const [percentage, setPercentage] = useState(0);
  const [successfulBills, setSuccefullBills] = useState({});
  const [unsuccessfulBills, setUnsuccefullBills] = useState({});

  useEffect(() => {
    getPayspotCurrentBillbox(payspotId).then(
      ({ used_capacity, successful_bills, unsuccessful_bills }) => {
        setPercentage(used_capacity * 100);
        setSuccefullBills(JSON.parse(successful_bills ?? '{}'));
        setUnsuccefullBills(JSON.parse(unsuccessful_bills ?? '{}'));
      }
    );
  }, [payspotId]);

  return (
    <>
      <h5>現在の金庫状況</h5>
      <Flex>
        <FlexColumn>
          <UsedCapacityCard percentage={percentage} />
          <PayspotErrorsCard payspotId={payspotId} />
        </FlexColumn>
        <FlexColumn>
          <BillsCard title="金庫内訳" bills={successfulBills} />
        </FlexColumn>
        <FlexColumn>
          <BillsCard title="(参考)エラー取引内訳" bills={unsuccessfulBills} />
        </FlexColumn>
      </Flex>
      <Flex>
        <FlexColumn>
          <MaintenanceLogsCard payspotId={payspotId} />
        </FlexColumn>
        <FlexColumn>
          <BillboxHistoryCard payspotId={payspotId} />
        </FlexColumn>
        <FlexColumn>
          <BillsBreakdownCard title="エラー取引履歴" payspotId={payspotId} />
        </FlexColumn>
      </Flex>
    </>
  );
};

PayspotDetails.propTypes = {
  payspotId: PropTypes.string.isRequired,
};

export default PayspotDetails;
